// M01 數系與近似值 - 練習題數據 (主題 16-17)
// 系統化設計，準備後續 Supabase 數據遷移
// 每個主題 10 題，共 20 題

// ========== 16. 複合誤差分析 (10題) ==========
export const M01_16_PROBLEMS = [
  {
    id: 'M01_16_P001',
    topicId: 'M01_16',
    question: "測量電阻 R₁ = 100 ± 2 Ω，R₂ = 50 ± 1 Ω，求串聯總電阻和誤差界限",
    solution: "R總 = 150 ± 3 Ω",
    explanation: "串聯：R總 = R₁ + R₂ = 100 + 50 = 150 Ω，加法誤差：ΔR總 = ΔR₁ + ΔR₂ = 2 + 1 = 3 Ω",
    hint: "串聯電阻的誤差直接相加",
    difficulty: 2,
    order: 1,
    steps: ["R總 = R₁ + R₂ = 100 + 50 = 150 Ω", "加法誤差：ΔR總 = ΔR₁ + ΔR₂", "= 2 + 1 = 3 Ω", "答案：150 ± 3 Ω"]
  },
  {
    id: 'M01_16_P002',
    topicId: 'M01_16',
    question: "測量電流 I = 2.0 ± 0.1 A，電壓 V = 12 ± 0.5 V，求功率和誤差界限",
    solution: "P = 24 ± 2 W",
    explanation: "功率 P = VI = 12 × 2.0 = 24 W，相對誤差：ΔP/P ≈ (ΔV/V) + (ΔI/I) = (0.5/12) + (0.1/2.0) = 0.092，ΔP ≈ 24 × 0.092 ≈ 2 W",
    hint: "乘法運算的相對誤差相加",
    difficulty: 3,
    order: 2,
    steps: ["P = VI = 12 × 2.0 = 24 W", "相對誤差：ΔP/P ≈ (ΔV/V) + (ΔI/I)", "= (0.5/12) + (0.1/2.0) = 0.092", "ΔP ≈ 24 × 0.092 ≈ 2 W", "答案：24 ± 2 W"]
  },
  {
    id: 'M01_16_P003',
    topicId: 'M01_16',
    question: "測量質量 m = 5.0 ± 0.2 kg，速度 v = 10 ± 0.5 m/s，求動能和誤差界限",
    solution: "Ek = 250 ± 30 J",
    explanation: "動能 Ek = ½mv² = ½ × 5.0 × 10² = 250 J，相對誤差：ΔEk/Ek ≈ (Δm/m) + 2(Δv/v) = (0.2/5.0) + 2(0.5/10) = 0.14，ΔEk ≈ 250 × 0.14 ≈ 35 J",
    hint: "v²項的誤差要乘以2",
    difficulty: 3,
    order: 3,
    steps: ["Ek = ½mv² = ½ × 5.0 × 100 = 250 J", "相對誤差：ΔEk/Ek ≈ (Δm/m) + 2(Δv/v)", "= (0.2/5.0) + 2(0.5/10) = 0.14", "ΔEk ≈ 250 × 0.14 ≈ 35 J", "答案：250 ± 35 J"]
  },
  {
    id: 'M01_16_P004',
    topicId: 'M01_16',
    question: "測量長度 L = 2.5 ± 0.1 m，寬度 W = 1.8 ± 0.1 m，高度 H = 1.2 ± 0.05 m，求體積和誤差界限",
    solution: "V = 5.4 ± 0.5 m³",
    explanation: "體積 V = L×W×H = 2.5×1.8×1.2 = 5.4 m³，相對誤差：ΔV/V ≈ (ΔL/L)+(ΔW/W)+(ΔH/H) = (0.1/2.5)+(0.1/1.8)+(0.05/1.2) ≈ 0.098，ΔV ≈ 5.4×0.098 ≈ 0.5 m³",
    hint: "三個量相乘的誤差傳播",
    difficulty: 3,
    order: 4,
    steps: ["V = L×W×H = 2.5×1.8×1.2 = 5.4 m³", "相對誤差：ΔV/V ≈ (ΔL/L)+(ΔW/W)+(ΔH/H)", "= (0.1/2.5)+(0.1/1.8)+(0.05/1.2)", "= 0.04+0.056+0.042 = 0.098", "ΔV ≈ 5.4×0.098 ≈ 0.5 m³"]
  },
  {
    id: 'M01_16_P005',
    topicId: 'M01_16',
    question: "測量溫度 T₁ = 25 ± 1°C，T₂ = 100 ± 2°C，求溫差和誤差界限",
    solution: "ΔT = 75 ± 3°C",
    explanation: "溫差 ΔT = T₂ - T₁ = 100 - 25 = 75°C，減法誤差：Δ(ΔT) = ΔT₁ + ΔT₂ = 1 + 2 = 3°C",
    hint: "減法運算的誤差也是相加",
    difficulty: 2,
    order: 5,
    steps: ["ΔT = T₂ - T₁ = 100 - 25 = 75°C", "減法誤差：Δ(ΔT) = ΔT₁ + ΔT₂", "= 1 + 2 = 3°C", "答案：75 ± 3°C"]
  },
  {
    id: 'M01_16_P006',
    topicId: 'M01_16',
    question: "測量半徑 r = 3.0 ± 0.1 cm，求球體體積和誤差界限",
    solution: "V = 113 ± 11 cm³",
    explanation: "球體體積 V = (4/3)πr³ = (4/3)π(3.0)³ = 113.1 cm³，相對誤差：ΔV/V ≈ 3(Δr/r) = 3(0.1/3.0) = 0.1，ΔV ≈ 113 × 0.1 ≈ 11 cm³",
    hint: "r³項的誤差要乘以3",
    difficulty: 3,
    order: 6,
    steps: ["V = (4/3)πr³ = (4/3)π(3.0)³ = 113.1 cm³", "相對誤差：ΔV/V ≈ 3(Δr/r)", "= 3(0.1/3.0) = 0.1", "ΔV ≈ 113 × 0.1 ≈ 11 cm³", "答案：113 ± 11 cm³"]
  },
  {
    id: 'M01_16_P007',
    topicId: 'M01_16',
    question: "測量密度 ρ = 2.5 ± 0.1 g/cm³，體積 V = 20 ± 1 cm³，求質量和誤差界限",
    solution: "m = 50 ± 4 g",
    explanation: "質量 m = ρV = 2.5 × 20 = 50 g，相對誤差：Δm/m ≈ (Δρ/ρ) + (ΔV/V) = (0.1/2.5) + (1/20) = 0.09，Δm ≈ 50 × 0.09 ≈ 4.5 g",
    hint: "密度乘以體積得質量",
    difficulty: 2,
    order: 7,
    steps: ["m = ρV = 2.5 × 20 = 50 g", "相對誤差：Δm/m ≈ (Δρ/ρ) + (ΔV/V)", "= (0.1/2.5) + (1/20) = 0.09", "Δm ≈ 50 × 0.09 ≈ 4.5 g", "答案：50 ± 5 g"]
  },
  {
    id: 'M01_16_P008',
    topicId: 'M01_16',
    question: "測量電阻 R = 10 ± 0.5 Ω，電流 I = 2.0 ± 0.1 A，求電壓和誤差界限",
    solution: "V = 20 ± 2 V",
    explanation: "電壓 V = IR = 2.0 × 10 = 20 V，相對誤差：ΔV/V ≈ (ΔI/I) + (ΔR/R) = (0.1/2.0) + (0.5/10) = 0.1，ΔV ≈ 20 × 0.1 = 2 V",
    hint: "歐姆定律 V = IR",
    difficulty: 2,
    order: 8,
    steps: ["V = IR = 2.0 × 10 = 20 V", "相對誤差：ΔV/V ≈ (ΔI/I) + (ΔR/R)", "= (0.1/2.0) + (0.5/10) = 0.1", "ΔV ≈ 20 × 0.1 = 2 V", "答案：20 ± 2 V"]
  },
  {
    id: 'M01_16_P009',
    topicId: 'M01_16',
    question: "測量加速度 a = 9.8 ± 0.2 m/s²，時間 t = 3.0 ± 0.1 s，求位移 s = ½at² 和誤差界限",
    solution: "s = 44 ± 4 m",
    explanation: "位移 s = ½at² = ½ × 9.8 × (3.0)² = 44.1 m，相對誤差：Δs/s ≈ (Δa/a) + 2(Δt/t) = (0.2/9.8) + 2(0.1/3.0) = 0.087，Δs ≈ 44 × 0.087 ≈ 4 m",
    hint: "t²項的誤差要乘以2",
    difficulty: 3,
    order: 9,
    steps: ["s = ½at² = ½ × 9.8 × 9 = 44.1 m", "相對誤差：Δs/s ≈ (Δa/a) + 2(Δt/t)", "= (0.2/9.8) + 2(0.1/3.0) = 0.087", "Δs ≈ 44 × 0.087 ≈ 4 m", "答案：44 ± 4 m"]
  },
  {
    id: 'M01_16_P010',
    topicId: 'M01_16',
    question: "測量圓周率實驗：周長 C = 31.4 ± 0.2 cm，直徑 d = 10.0 ± 0.1 cm，求 π 值和誤差界限",
    solution: "π = 3.14 ± 0.05",
    explanation: "π = C/d = 31.4/10.0 = 3.14，相對誤差：Δπ/π ≈ (ΔC/C) + (Δd/d) = (0.2/31.4) + (0.1/10.0) = 0.016，Δπ ≈ 3.14 × 0.016 ≈ 0.05",
    hint: "除法運算的相對誤差相加",
    difficulty: 3,
    order: 10,
    steps: ["π = C/d = 31.4/10.0 = 3.14", "相對誤差：Δπ/π ≈ (ΔC/C) + (Δd/d)", "= (0.2/31.4) + (0.1/10.0) = 0.016", "Δπ ≈ 3.14 × 0.016 ≈ 0.05", "答案：3.14 ± 0.05"]
  }
];

// ========== 17. 百分誤差轉換 (10題) ==========
export const M01_17_PROBLEMS = [
  {
    id: 'M01_17_P001',
    topicId: 'M01_17',
    question: "測量值為 25.0 cm，百分誤差為 2%，求絕對誤差界限",
    solution: "±0.5 cm",
    explanation: "絕對誤差 = 百分誤差 × 測量值 / 100% = 2% × 25.0 / 100% = 0.5 cm",
    hint: "百分誤差轉絕對誤差",
    difficulty: 1,
    order: 1,
    steps: ["絕對誤差 = 百分誤差 × 測量值 / 100%", "= 2% × 25.0 / 100%", "= 0.5 cm", "答案：±0.5 cm"]
  },
  {
    id: 'M01_17_P002',
    topicId: 'M01_17',
    question: "電阻測量值 100 Ω，絕對誤差 ±5 Ω，求百分誤差",
    solution: "5%",
    explanation: "百分誤差 = (絕對誤差 / 測量值) × 100% = (5 / 100) × 100% = 5%",
    hint: "絕對誤差轉百分誤差",
    difficulty: 1,
    order: 2,
    steps: ["百分誤差 = (絕對誤差 / 測量值) × 100%", "= (5 / 100) × 100%", "= 5%"]
  },
  {
    id: 'M01_17_P003',
    topicId: 'M01_17',
    question: "溫度測量 50°C，要求百分誤差不超過 1%，絕對誤差應控制在多少？",
    solution: "±0.5°C",
    explanation: "絕對誤差 ≤ 百分誤差 × 測量值 / 100% = 1% × 50 / 100% = 0.5°C",
    hint: "從百分誤差要求推算絕對誤差",
    difficulty: 2,
    order: 3,
    steps: ["絕對誤差 ≤ 百分誤差 × 測量值 / 100%", "= 1% × 50 / 100%", "= 0.5°C", "答案：±0.5°C"]
  },
  {
    id: 'M01_17_P004',
    topicId: 'M01_17',
    question: "質量 200 g，絕對誤差 ±3 g，求百分誤差並判斷是否滿足 2% 的精度要求",
    solution: "1.5%，滿足要求",
    explanation: "百分誤差 = (3 / 200) × 100% = 1.5% < 2%，滿足精度要求",
    hint: "計算百分誤差並與要求比較",
    difficulty: 2,
    order: 4,
    steps: ["百分誤差 = (3 / 200) × 100% = 1.5%", "1.5% < 2%", "滿足精度要求"]
  },
  {
    id: 'M01_17_P005',
    topicId: 'M01_17',
    question: "電壓 12 V，百分誤差 3%，電流 2 A，百分誤差 2%，求功率的百分誤差",
    solution: "5%",
    explanation: "功率 P = VI，乘法運算的百分誤差相加：百分誤差(P) = 百分誤差(V) + 百分誤差(I) = 3% + 2% = 5%",
    hint: "乘法運算的百分誤差相加",
    difficulty: 2,
    order: 5,
    steps: ["P = VI（乘法運算）", "百分誤差(P) = 百分誤差(V) + 百分誤差(I)", "= 3% + 2% = 5%"]
  },
  {
    id: 'M01_17_P006',
    topicId: 'M01_17',
    question: "長度 L = 5.0 m，百分誤差 2%，求面積 A = L² 的百分誤差",
    solution: "4%",
    explanation: "面積 A = L²，平方運算的百分誤差要乘以2：百分誤差(A) = 2 × 百分誤差(L) = 2 × 2% = 4%",
    hint: "平方運算的百分誤差要乘以指數",
    difficulty: 2,
    order: 6,
    steps: ["A = L²（平方運算）", "百分誤差(A) = 2 × 百分誤差(L)", "= 2 × 2% = 4%"]
  },
  {
    id: 'M01_17_P007',
    topicId: 'M01_17',
    question: "半徑 r = 2.0 cm，百分誤差 1.5%，求圓面積的百分誤差",
    solution: "3%",
    explanation: "圓面積 A = πr²，r²項的百分誤差 = 2 × 1.5% = 3%，π是常數不影響誤差",
    hint: "常數不影響百分誤差",
    difficulty: 2,
    order: 7,
    steps: ["A = πr²", "π是常數，不影響誤差", "百分誤差(A) = 2 × 百分誤差(r)", "= 2 × 1.5% = 3%"]
  },
  {
    id: 'M01_17_P008',
    topicId: 'M01_17',
    question: "測量密度實驗：質量 50 g（百分誤差 1%），體積 20 cm³（百分誤差 2%），求密度的百分誤差",
    solution: "3%",
    explanation: "密度 ρ = m/V，除法運算的百分誤差相加：百分誤差(ρ) = 百分誤差(m) + 百分誤差(V) = 1% + 2% = 3%",
    hint: "除法運算的百分誤差也相加",
    difficulty: 2,
    order: 8,
    steps: ["ρ = m/V（除法運算）", "百分誤差(ρ) = 百分誤差(m) + 百分誤差(V)", "= 1% + 2% = 3%"]
  },
  {
    id: 'M01_17_P009',
    topicId: 'M01_17',
    question: "速度 v = 10 m/s，百分誤差 2%，質量 m = 2 kg，百分誤差 1%，求動能 Ek = ½mv² 的百分誤差",
    solution: "5%",
    explanation: "動能 Ek = ½mv²，百分誤差(Ek) = 百分誤差(m) + 2×百分誤差(v) = 1% + 2×2% = 5%",
    hint: "v²項的百分誤差要乘以2",
    difficulty: 3,
    order: 9,
    steps: ["Ek = ½mv²", "½是常數，不影響誤差", "百分誤差(Ek) = 百分誤差(m) + 2×百分誤差(v)", "= 1% + 2×2% = 5%"]
  },
  {
    id: 'M01_17_P010',
    topicId: 'M01_17',
    question: "若要求測量結果的百分誤差不超過 0.5%，兩個相等量值相乘，每個量的百分誤差應控制在多少？",
    solution: "0.25%",
    explanation: "設每個量的百分誤差為 x，相乘後總百分誤差 = x + x = 2x ≤ 0.5%，所以 x ≤ 0.25%",
    hint: "相乘的百分誤差相加",
    difficulty: 2,
    order: 10,
    steps: ["設每個量的百分誤差為 x", "相乘後總百分誤差 = x + x = 2x", "要求：2x ≤ 0.5%", "所以：x ≤ 0.25%"]
  }
]; 